<div class="min-h-screen bg-mist flex overflow-x-hidden" [class.logout-animating]="isAnimating()">
	<!-- Mobile Overlay Backdrop -->
	@if (mobileMenuOpen()) {
		<div
			class="fixed inset-0 bg-black/50 z-40 md:hidden"
			(click)="toggleMobileMenu()"
		></div>
	}

	<!-- Sidebar -->
	<aside
		class="bg-primary shadow-2xl flex flex-col fixed h-screen z-50 sidebar-panel transition-transform duration-300 -translate-x-full md:translate-x-0"
		[class.w-72]="!isAnimating()"
		[class.animate-expand]="isAnimating()"
		[class.translate-x-0]="mobileMenuOpen()"
	>
		<!-- All Sidebar Content Wrapper -->
		<div
			class="flex flex-col h-full overflow-hidden sidebar-content"
			[style.opacity]="isAnimating() ? '0' : '1'"
			[style.transition]="'opacity 300ms ease-out'"
		>
			<!-- Logo Section -->
			<div
				class="p-6 border-b border-white/10 fade-in-element delay-100"
				[class.show]="showSidebar()"
			>
				<app-logo [variant]="'light'" [size]="'md'" [isLink]="false"></app-logo>
				<p class="text-secondary/80 text-xs mt-2 tracking-wider">ADMIN PORTAL</p>
			</div>

		<!-- Navigation -->
		<nav class="flex-1 px-4 py-6 overflow-y-auto">
				<div class="space-y-2">
					<!-- Dashboard -->
					<a
						routerLink="/admin/dashboard"
						routerLinkActive="active-link"
						class="nav-link group flex items-center gap-3 px-4 py-3 rounded-xl text-mist/80 hover:text-mist hover:bg-white/10 transition-all duration-300 fade-in-element delay-200"
						[class.show]="showSidebar()"
					>
						<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
							/>
						</svg>
						<span class="font-medium">Dashboard</span>
					</a>

					<!-- Services -->
					<a
						routerLink="/admin/services"
						routerLinkActive="active-link"
						class="nav-link group flex items-center gap-3 px-4 py-3 rounded-xl text-mist/80 hover:text-mist hover:bg-white/10 transition-all duration-300 fade-in-element delay-300"
						[class.show]="showSidebar()"
					>
						<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
							/>
						</svg>
						<span class="font-medium">Services</span>
					</a>

					<!-- Service Categories -->
					<a
						routerLink="/admin/service-categories"
						routerLinkActive="active-link"
						class="nav-link group flex items-center gap-3 px-4 py-3 rounded-xl text-mist/80 hover:text-mist hover:bg-white/10 transition-all duration-300 fade-in-element delay-350"
						[class.show]="showSidebar()"
					>
						<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
							/>
						</svg>
						<span class="font-medium">Categories</span>
					</a>

					<!-- Staff -->
					<a
						routerLink="/admin/staff"
						routerLinkActive="active-link"
						class="nav-link group flex items-center gap-3 px-4 py-3 rounded-xl text-mist/80 hover:text-mist hover:bg-white/10 transition-all duration-300 fade-in-element delay-400"
						[class.show]="showSidebar()"
					>
						<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
							/>
						</svg>
						<span class="font-medium">Staff</span>
					</a>

					<!-- Staff Leaves -->
					<a
						routerLink="/admin/leaves"
						routerLinkActive="active-link"
						class="nav-link group flex items-center gap-3 px-4 py-3 rounded-xl text-mist/80 hover:text-mist hover:bg-white/10 transition-all duration-300 fade-in-element delay-420"
						[class.show]="showSidebar()"
					>
						<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
							/>
						</svg>
						<span class="font-medium">Staff Leaves</span>
					</a>

					<!-- Customers -->
					<a
						routerLink="/admin/customers"
						routerLinkActive="active-link"
						class="nav-link group flex items-center gap-3 px-4 py-3 rounded-xl text-mist/80 hover:text-mist hover:bg-white/10 transition-all duration-300 fade-in-element delay-450"
						[class.show]="showSidebar()"
					>
						<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
							/>
						</svg>
						<span class="font-medium">Customers</span>
					</a>

					<!-- Appointments -->
					<a
						routerLink="/admin/appointments"
						routerLinkActive="active-link"
						class="nav-link group flex items-center gap-3 px-4 py-3 rounded-xl text-mist/80 hover:text-mist hover:bg-white/10 transition-all duration-300 fade-in-element delay-475"
						[class.show]="showSidebar()"
					>
						<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
							/>
						</svg>
						<span class="font-medium">Appointments</span>
					</a>

					<!-- Testimonials -->
					<a
						routerLink="/admin/testimonials"
						routerLinkActive="active-link"
						class="nav-link group flex items-center gap-3 px-4 py-3 rounded-xl text-mist/80 hover:text-mist hover:bg-white/10 transition-all duration-300 fade-in-element delay-487"
						[class.show]="showSidebar()"
					>
						<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
							/>
						</svg>
						<span class="font-medium">Testimonials</span>
					</a>

					<!-- Blogs -->
					<a
						routerLink="/admin/blog"
						routerLinkActive="active-link"
						class="nav-link group flex items-center gap-3 px-4 py-3 rounded-xl text-mist/80 hover:text-mist hover:bg-white/10 transition-all duration-300 fade-in-element delay-500"
						[class.show]="showSidebar()"
					>
						<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
							/>
						</svg>
						<span class="font-medium">Blogs</span>
					</a>

					<!-- Site Settings -->
					<a
						routerLink="/admin/site-settings"
						routerLinkActive="active-link"
						class="nav-link group flex items-center gap-3 px-4 py-3 rounded-xl text-mist/80 hover:text-mist hover:bg-white/10 transition-all duration-300 fade-in-element delay-525"
						[class.show]="showSidebar()"
					>
						<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
							/>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
							/>
						</svg>
						<span class="font-medium">Site Settings</span>
					</a>
				</div>
			</nav>
			<!-- User Section -->
			<div
				class="p-4 border-t border-white/10 fade-in-element delay-400"
				[class.show]="showSidebar()"
			>
				<div class="flex items-center gap-3 px-4 py-3 bg-white/5 rounded-xl">
					<div
						class="w-10 h-10 rounded-full bg-secondary flex items-center justify-center flex-shrink-0"
					>
						<span class="text-primary font-bold text-sm">{{ getUserInitials() }}</span>
					</div>
					<div class="flex-1 min-w-0">
						<p class="text-mist font-medium text-sm truncate">{{ getUserName() }}</p>
						<p class="text-secondary/80 text-xs">Administrator</p>
					</div>
				</div>
				<button
					(click)="logout()"
					[disabled]="isLoggingOut()"
					class="w-full mt-3 flex items-center justify-center gap-2 px-4 py-2.5 bg-white/10 hover:bg-white/20 text-mist rounded-lg transition-all duration-300 group disabled:opacity-50 disabled:cursor-not-allowed"
				>
					@if (isLoggingOut()) {
					<svg
						class="animate-spin h-4 w-4"
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
					>
						<circle
							class="opacity-25"
							cx="12"
							cy="12"
							r="10"
							stroke="currentColor"
							stroke-width="4"
						></circle>
						<path
							class="opacity-75"
							fill="currentColor"
							d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
						></path>
					</svg>
					<span class="text-sm font-medium">Logging out...</span>
					} @else {
					<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
						/>
					</svg>
					<span class="text-sm font-medium">Logout</span>
					}
				</button>
			</div>
		</div>
		<!-- End Sidebar Content Wrapper -->
	</aside>

	<!-- Main Content -->
	<main
		class="flex-1 md:ml-72 fade-in-element overflow-x-hidden min-w-0"
		[class.show]="showContent()"
		[style.display]="isAnimating() ? 'none' : 'block'"
	>
	<!-- Top Header -->
	<header class="bg-white shadow-sm border-b border-charcoal/10 sticky top-0 z-40">
		<!-- Mobile Top Row: Menu + Logo -->
		<div class="md:hidden px-4 py-2 flex items-center justify-between border-b border-charcoal/5">
			<div class="flex items-center gap-3">
				<!-- Mobile Menu Toggle Button -->
				<button
					(click)="toggleMobileMenu()"
					class="p-2 hover:bg-primary/10 rounded-lg transition-colors"
					aria-label="Toggle menu"
				>
					<svg
						class="w-6 h-6 text-charcoal"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
					>
						@if (mobileMenuOpen()) {
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M6 18L18 6M6 6l12 12"
							/>
						} @else {
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M4 6h16M4 12h16M4 18h16"
							/>
						}
					</svg>
				</button>
				<!-- Mobile Logo -->
				<app-logo [variant]="'dark'" [size]="'xs'" [isLink]="false" [showShadow]="false"></app-logo>
			</div>
			<!-- Notifications (mobile top row) -->
			<button
				class="w-8 h-8 rounded-full bg-mist hover:bg-charcoal/5 flex items-center justify-center transition-colors relative"
			>
				<svg
					class="w-4 h-4 text-charcoal"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
					/>
				</svg>
				<span class="absolute top-1 right-1 w-2 h-2 bg-primary rounded-full"></span>
			</button>
		</div>
		<!-- Main Row: Title + Actions -->
		<div class="px-4 py-2 md:px-8 md:py-4 flex items-center justify-between">
			<div class="flex items-center gap-2 md:gap-3 min-w-0 flex-1">
				<!-- Back Button (shown when headerConfig has backButton) -->
				@if (adminHeaderService.headerConfig().backButton?.show) {
					<button
						(click)="adminHeaderService.headerConfig().backButton!.callback()"
						class="p-2 hover:bg-primary/10 rounded-lg transition-colors group"
					>
						<svg
							class="w-5 h-5 text-charcoal/60 group-hover:text-primary transition-colors"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M15 19l-7-7 7-7"
							/>
						</svg>
					</button>
				}
				<div class="min-w-0">
					<h1 class="text-base md:text-2xl font-cenzo font-bold text-primary truncate">{{ getPageTitle() }}</h1>
					<p class="text-charcoal/60 text-xs md:text-sm mt-0.5 md:mt-1 hidden md:block">{{ getPageSubtitle() }}</p>
				</div>
			</div>
			<div class="flex items-center gap-2 md:gap-4 shrink-0">
				<!-- Page Actions (dynamically shown based on headerConfig) -->
				@if (adminHeaderService.headerConfig().actions && adminHeaderService.headerConfig().actions!.length > 0) {
					@for (action of adminHeaderService.headerConfig().actions; track $index) {
						@if (action.variant === 'danger') {
							<button
								(click)="action.callback()"
								[disabled]="action.disabled"
								class="p-2 md:p-2.5 rounded-lg transition-all duration-200 text-red-600 hover:text-white hover:bg-red-600 hover:shadow-md"
								[title]="action.label"
							>
								@if (action.icon) {
									<svg class="w-4 h-4 md:w-5 md:h-5 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="action.icon"/>
									</svg>
								}
							</button>
						} @else if (action.variant === 'secondary') {
							<button
								(click)="action.callback()"
								[disabled]="action.disabled"
							class="inline-flex items-center gap-1.5 md:gap-2 px-2.5 py-1.5 md:px-5 md:py-2.5 bg-white border-2 border-primary/30 rounded-lg md:rounded-xl font-semibold text-primary hover:bg-primary/5 transition-all disabled:opacity-50 shadow-md hover:shadow-lg text-xs md:text-base"
						>
							@if (action.icon) {
								<svg class="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="action.icon"/>
								</svg>
							}
							<span class="hidden sm:inline">{{ action.label }}</span>
							</button>
						} @else {
							<button
								(click)="action.callback()"
								[disabled]="action.disabled"
							class="inline-flex items-center gap-1.5 md:gap-2 px-2.5 py-1.5 md:px-6 md:py-2.5 bg-gradient-to-r from-primary to-secondary text-white rounded-lg md:rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all hover:scale-105 disabled:opacity-50 text-xs md:text-base"
						>
							@if (action.icon) {
								<svg class="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="action.icon"/>
								</svg>
							}
							<span class="hidden sm:inline">{{ action.label }}</span>
							</button>
						}
					}
				}

				<!-- Legacy single action button (for backward compatibility) -->
				@if (adminHeaderService.headerAction() && (!adminHeaderService.headerConfig().actions || adminHeaderService.headerConfig().actions!.length === 0)) {
					<button
						(click)="adminHeaderService.headerAction()!.callback()"
						class="flex items-center gap-1.5 md:gap-2 px-2.5 py-1.5 md:px-6 md:py-3 bg-gradient-to-r from-primary to-secondary text-white rounded-lg md:rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 text-xs md:text-base">
						<svg class="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="adminHeaderService.headerAction()!.icon"/>
						</svg>
						<span class="hidden sm:inline">{{ adminHeaderService.headerAction()!.label }}</span>
					</button>
				}

				<!-- Notifications (desktop only) -->
				<button
					class="hidden md:flex w-10 h-10 rounded-full bg-mist hover:bg-charcoal/5 items-center justify-center transition-colors relative"
				>
					<svg
						class="w-5 h-5 text-charcoal"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
						/>
					</svg>
					<span class="absolute top-1 right-1 w-2 h-2 bg-primary rounded-full"></span>
				</button>
			</div>
		</div>
	</header>

	<!-- Page Content -->
	<div class="p-4 md:p-8 overflow-x-auto">
		<router-outlet></router-outlet>
	</div>
</main>

<!-- Global Modal Component -->
<app-modal></app-modal>

<!-- Global Booking Modal (for admin appointments) -->
@if (bookingModalService.isOpen()) {
	<app-booking-modal (close)="bookingModalService.close()"></app-booking-modal>
}
</div>
